import { useTelemetryStore } from "../stores/telemetryStore";
import { useUIStore } from "../stores/uiStore";
import { AlertBeam } from "./primitives/AlertBeam";

export function AlertBeamLayer() {
  const alerts    = useTelemetryStore((s) => s.alerts);
  const forklifts = useTelemetryStore((s) => s.forklifts);
  const visible   = useUIStore((s) => s.layers.alerts);

  if (!visible) return null;

  return (
    <>
      {Object.values(alerts)
        .filter((a) => a.status === "open")
        .map((a) => {
          // A beam needs a body to stand on: inventory alerts (assetId null,
          // ADR 282) and alerts whose asset has no live pose draw nothing —
          // the old (0,0) fallback planted beams at the world origin.
          const fork = a.assetId ? forklifts[a.assetId] : undefined;
          return fork ? <AlertBeam key={a.id} alert={a} x={fork.x} z={fork.y} /> : null;
        })}
    </>
  );
}
